import React, { useState } from 'react'
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport } from '@mui/x-data-grid'

const CustomToolbar = (props) => {
    return (
        <GridToolbarContainer sx={{ mb: 1 }}>
            <GridToolbarExport />
            <GridToolbarColumnsButton />
            <GridToolbarDensitySelector />
        </GridToolbarContainer>
    );
}

const MyTable = ({
    rows,
    columns,
    // url,
    row_id,
    onRowClick,
    isLoading = false,
    cursorPointer = false
}) => {
    const [pageSize, setPageSize] = useState(10);

    return (
        <div style={{ width: '100%' }}>
            <DataGrid
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[10, 20, 100]}
                pagination
                density='comfortable'
                autoHeight={true}
                components={{
                    Toolbar: CustomToolbar,
                }}
                getRowId={row_id}
                sx={{
                    border: 'none'
                }}
                initialState={{
                    sorting: {
                        sortModel: [{field: 'created_at', sort: 'asc'}]
                    }
                }}
                onRowClick={onRowClick}
                loading={isLoading}
                className={cursorPointer ? "cursorPointer" : ""}
            />
        </div>
    )
}

MyTable.propTypes = {}

export default MyTable